import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/coinbase_wallet.svg'
import _imports_1 from '@/assets/images/wallet_connect.svg'


const _hoisted_1 = {
  key: 0,
  class: "bad-configuration"
}
const _hoisted_2 = {
  key: 1,
  class: "m-connection-container"
}
const _hoisted_3 = {
  key: 0,
  class: "m-connected-container"
}
const _hoisted_4 = {
  key: 1,
  class: "m-connection-wrong-network",
  disabled: ""
}
const _hoisted_5 = {
  key: 0,
  class: "m-connection-avatar"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "m-connection-balance"
}
const _hoisted_8 = { class: "m-connection-wallet" }
const _hoisted_9 = {
  key: 3,
  class: "m-connection-dropdown"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "m-connection-wallet-logo",
  src: _imports_0
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Coinbase Wallet ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "m-connection-wallet-logo",
  src: _imports_1
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Wallet Connect ")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "m-connection",
    class: _normalizeClass({ connected: _ctx.oauthToken, menu: _ctx.showConnectedMenu })
  }, [
    (_ctx.badConfiguration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", null, _toDisplayString(_ctx.badConfiguration), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.oauthToken || (_ctx.delayAuth && _ctx.walletConnected))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.wrongChain && _ctx.enableNetworkSwitching)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "m-connection-switch-network",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchNetwork && _ctx.switchNetwork(...args)))
                    }, " Switch network "))
                  : (_ctx.wrongChain)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_4, " Wrong network "))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "m-connection-disconnect-wallet",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConnectedMenu = !_ctx.showConnectedMenu))
                      }, [
                        (_ctx.avatar)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                              _createElementVNode("img", {
                                class: "m-connection-avatar-img",
                                src: _ctx.avatar
                              }, null, 8, _hoisted_6)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.wrongChain && _ctx.showBalance)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.walletBalance) + " ETH ", 1))
                          : _createCommentVNode("", true),
                        (!_ctx.wrongChain && _ctx.showChain && _ctx.chainInfo)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: "m-connection-chain-id",
                              style: _normalizeStyle({ 'background-color': _ctx.chainInfo.color.toString() })
                            }, null, 4))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.walletENS ? _ctx.walletENS : _ctx.walletAddressShort), 1)
                      ])),
                (_ctx.showConnectedMenu)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _renderSlot(_ctx.$slots, "dropdown"),
                      (_ctx.walletConnected)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "m-connection-disconnect-wallet",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.disconnectAndClose && _ctx.disconnectAndClose(...args)))
                          }, [
                            _createElementVNode("span", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showConnectedMenu = !_ctx.showConnectedMenu))
                            }, " Disconnect ")
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (!_ctx.showConnectOptions && (!_ctx.alwaysOpen || _ctx.isLoading))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: _ctx.isLoading,
                  class: "m-connection-connect-wallet",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setShowConnectOptions && _ctx.setShowConnectOptions(...args)))
                }, [
                  _createElementVNode("span", { innerHTML: _ctx.buttonText }, null, 8, _hoisted_11)
                ], 8, _hoisted_10))
              : _createCommentVNode("", true)
        ])),
    ((_ctx.showConnectOptions || _ctx.alwaysOpen) && !_ctx.walletConnected && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "m-connection-wallet-options",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeConnectOptions && _ctx.closeConnectOptions(...args)))
        }, [
          (_ctx.browserWallets.length >= 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.browserWallets, (wallet) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: wallet.name,
                    class: "m-connection-wallet-option",
                    disabled: _ctx.isLoading,
                    onClick: ($event: any) => (_ctx.connectBrowserWallet(wallet.name, wallet.provider!))
                  }, [
                    (wallet.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "m-connection-wallet-logo",
                          src: wallet.logo
                        }, null, 8, _hoisted_14))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(wallet.name), 1)
                  ], 8, _hoisted_13))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.browserWallets.map((w) => w.name).includes('Coinbase Wallet'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "m-connection-wallet-option coinbase",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.connectCoinbaseWallet && _ctx.connectCoinbaseWallet(...args)))
              }, _hoisted_17))
            : _createCommentVNode("", true),
          (_ctx.walletConnectProjectId && !_ctx.walletsHidden.has('wallet connect'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "m-connection-wallet-option walletconnect",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.connectWalletConnect && _ctx.connectWalletConnect(...args)))
              }, _hoisted_20))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}